//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mapState
} from "vuex";

export default {
  data() {
    return {
      noIndex: false,
    };
  },
  async beforeMount() {
  },
  mounted() {
    this.keepLang()
  },
  components: {},
  computed: {
    ...mapState([
      "categories",'campaign'
    ])
  },
  methods: {
    goHomeWithFilter(typeId,catId){
      this.$router.push({
        path: `/home/${this.$route.query.cid}`,
        query:{ type: typeId, cat: catId, cid: this.$route.query.cid }
      })
    },
    keepLang(){
      let locale = localStorage.locale;
      this.$i18n.locale = locale === 'en' ? locale : 'zh';
    },
  },
  watch: {}
};



// WEBPACK FOOTER //
// ./src/pages/cat/Cat.vue